(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8575],{

/***/ 59186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var components_lobbypage_components_PageBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57640);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75741);
/* harmony import */ var theme_GlobalStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14808);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var StyledDescriptionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Description__StyledDescriptionWrapper",
  componentId: "sc-wg9h44-0"
})(["", "{}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  component: "h1",
  variant: "h2"
}).withConfig({
  displayName: "Description__StyledTitle",
  componentId: "sc-wg9h44-1"
})(["font-size:44px;font-weight:normal;margin-top:10px;margin-bottom:20px;line-height:1;", " color:", ";", "{font-size:70px;}"], theme_GlobalStyle__WEBPACK_IMPORTED_MODULE_2__/* .fontCondensed */ .gH, theme_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"].blackDark */ .Z.blackDark, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  component: "p",
  variant: "h2"
}).withConfig({
  displayName: "Description__StyledSubtitle",
  componentId: "sc-wg9h44-2"
})(["margin-top:0;margin-bottom:10px;font-size:18px;font-weight:normal;"]);
var StyledDescription = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
  component: "div",
  variant: "body1"
}).withConfig({
  displayName: "Description__StyledDescription",
  componentId: "sc-wg9h44-3"
})(["margin-bottom:10px;margin-top:0;font-size:14px;font-weight:400;color:", ";white-space:break-spaces;line-height:1.57;", "{margin-bottom:20px;}p{margin:0;}a{text-decoration:underline;}ul{margin:0.5em 0;padding-inline-start:1.3em;li::marker{color:", ";}}"], theme_colors__WEBPACK_IMPORTED_MODULE_1__/* ["default"].black */ .Z.black, function (p) {
  return p.theme.breakpoints.up("md");
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.red;
}); //to remove

var Description = function Description(_ref2) {
  var data = _ref2.data,
      parentPageType = _ref2.parentPageType;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledDescriptionWrapper, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_lobbypage_components_PageBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      thisPageName: data.title,
      parentPageType: parentPageType
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledTitle, {
      children: data.title
    }), data.subtitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledSubtitle, {
      children: data.subtitle
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledDescription, {
      dangerouslySetInnerHTML: {
        __html: data === null || data === void 0 ? void 0 : data.description
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Description);

/***/ }),

/***/ 51484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MV": function() { return /* binding */ LOCALE; },
/* harmony export */   "Wj": function() { return /* binding */ CONSTRUCTION; },
/* harmony export */   "k6": function() { return /* binding */ mapsApiKey; }
/* harmony export */ });
var mapsApiKey = "AIzaSyCj0ryj5kLFxMmeAGUP3X4lftkoVfmcCuU";
var LOCALE = {
  EN: "en",
  HE: "he"
};
var CONSTRUCTION = "construction";

/***/ }),

/***/ 57640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_Breadcrumbs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7885);
/* harmony import */ var common_utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51484);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32125);
/* harmony import */ var _common_NextLink__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44074);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);








 //Styles




var StyledBreadcrumbs = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Breadcrumbs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
  displayName: "PageBreadcrumbs__StyledBreadcrumbs",
  componentId: "sc-t3c85e-0"
})(["", "{padding-top:20px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledActiveLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
  displayName: "PageBreadcrumbs__StyledActiveLink",
  componentId: "sc-t3c85e-1"
})(["font-weight:bold;color:", ";"], function (p) {
  return p.theme.colors.black;
});

var PageBreadcrumbs = function PageBreadcrumbs(_ref) {
  var thisPageName = _ref.thisPageName,
      parentPageType = _ref.parentPageType,
      assetType = _ref.assetType;
  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_9__.useTranslations)("breadcrumbs");

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      asPath = _useRouter.asPath;

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (window !== undefined) {
      setTimeout(function () {
        var lastLi = document.querySelector("#breadcrumbs li:last-child"); // add aria-current="page" to the last li

        lastLi === null || lastLi === void 0 ? void 0 : lastLi.setAttribute("aria-current", "page");
      });
    }
  }, []);

  var getParentPageUrl = function getParentPageUrl(parentPageType) {
    return parentPageType === "all-assets" ? "/assets-list/all-assets" : parentPageType === "assets-list" ? "/assets-list/offices" : parentPageType === "about" ? "/about/about-us" : parentPageType === "investments" ? "/about/about-us" : "/investor-relations";
  };

  var breadcrumbArray = [{
    position: 1,
    name: t("main"),
    item: "/"
  }, {
    position: 2,
    name: t(parentPageType),
    item: getParentPageUrl(parentPageType)
  }, {
    position: 3,
    name: thisPageName,
    item: asPath
  }];

  if (assetType) {
    var assetItem = {
      position: 3,
      name: t(assetType),
      item: "/assets-list/".concat(assetType)
    };
    breadcrumbArray.splice(2, 0, assetItem);
    breadcrumbArray[3].position = 4;
  }

  if (assetType === common_utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONSTRUCTION */ .Wj) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledBreadcrumbs, {
        id: "breadcrumbs",
        separator: "//",
        "aria-label": t("navAria"),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            variant: "body2",
            children: t("main")
          })
        }), thisPageName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          href: "/construction",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            variant: "body2",
            children: t("construction")
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledActiveLink, {
          variant: "body2",
          children: thisPageName || t("construction")
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .BreadcrumbJsonLd */ .gR, {
        itemListElements: breadcrumbArray
      })]
    });
  } //Render


  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(StyledBreadcrumbs, {
      id: "breadcrumbs",
      separator: "//",
      "aria-label": t("navAria"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        href: "/",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          variant: "body2",
          children: t("main")
        })
      }), parentPageType && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        href: getParentPageUrl(parentPageType),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          variant: "body2",
          children: t(parentPageType)
        })
      }), assetType && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_NextLink__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        href: "/assets-list/".concat(assetType),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          variant: "body2",
          children: t(assetType)
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(StyledActiveLink, {
        variant: "body2",
        children: thisPageName
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .BreadcrumbJsonLd */ .gR, {
      itemListElements: breadcrumbArray
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageBreadcrumbs);

/***/ }),

/***/ 44739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ investor_relations_shareholders; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./common/Description.tsx
var Description = __webpack_require__(59186);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(28696);
// EXTERNAL MODULE: ./common/StickyImagePageLayout.tsx + 1 modules
var StickyImagePageLayout = __webpack_require__(19441);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./theme/GlobalStyle.tsx
var GlobalStyle = __webpack_require__(14808);
// EXTERNAL MODULE: ./node_modules/chart.js/dist/chart.js
var chart = __webpack_require__(23148);
;// CONCATENATED MODULE: ./node_modules/chart.js/auto/auto.js


chart/* Chart.register */.kL.register(...chart/* registerables */.zX);


/* harmony default export */ var auto = ((/* unused pure expression or super */ null && (Chart)));

// EXTERNAL MODULE: ./node_modules/chartjs-plugin-datalabels/dist/chartjs-plugin-datalabels.esm.js
var chartjs_plugin_datalabels_esm = __webpack_require__(57028);
// EXTERNAL MODULE: ./node_modules/react-chartjs-2/dist/index.js
var dist = __webpack_require__(26495);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/shareHolders/SharedHoldersChart.tsx









chart/* Chart.register */.kL.register(chart/* ArcElement */.qi, chartjs_plugin_datalabels_esm/* default */.Z);
chart/* Chart.defaults.plugins.datalabels.align */.kL.defaults.plugins.datalabels.align = "end";
chart/* Chart.defaults.plugins.datalabels.anchor */.kL.defaults.plugins.datalabels.anchor = "end";
var SharedHoldersChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SharedHoldersChart__SharedHoldersChartWrapper",
  componentId: "sc-hsg58l-0"
})(["position:relative;width:100%;height:400px;display:flex;justify-content:center;", "{height:300px;width:400px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledDoughnutWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SharedHoldersChart__StyledDoughnutWrapper",
  componentId: "sc-hsg58l-1"
})(["width:356px;height:356px;position:absolute;top:0;direction:ltr;", "{width:400px;height:400px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledPieWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SharedHoldersChart__StyledPieWrapper",
  componentId: "sc-hsg58l-2"
})(["width:50px;height:40px;position:absolute;top:154px;", "{height:70px;width:70px;top:165px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});

var SharedHoldersChart = function SharedHoldersChart(_ref) {
  var dataSharedHolders = _ref.dataSharedHolders;
  var t = (0,next_intl_cjs_production_min.useTranslations)("shareholders");
  var labels = dataSharedHolders === null || dataSharedHolders === void 0 ? void 0 : dataSharedHolders.map(function (sharedHolder) {
    return sharedHolder.shareholderName.value.split(" ").join("\n") + "\n" + sharedHolder.sharePercentage.value + "%";
  });
  var dataChart = {
    labels: labels,
    datasets: [{
      data: dataSharedHolders === null || dataSharedHolders === void 0 ? void 0 : dataSharedHolders.map(function (sharedNumber) {
        var _sharedNumber$sharePe;

        return parseInt((_sharedNumber$sharePe = sharedNumber.sharePercentage) === null || _sharedNumber$sharePe === void 0 ? void 0 : _sharedNumber$sharePe.value);
      }),
      backgroundColor: dataSharedHolders === null || dataSharedHolders === void 0 ? void 0 : dataSharedHolders.map(function (dataSharedHolder, i) {
        return "rgba(217, 0, 29," + 1 / (dataSharedHolders === null || dataSharedHolders === void 0 ? void 0 : dataSharedHolders.length) * (((dataSharedHolders === null || dataSharedHolders === void 0 ? void 0 : dataSharedHolders.length) || 0) - i) + ")";
      }),
      borderColor: "transparent"
    }]
  };
  var chartOptions = {
    rotation: 0,
    layout: {
      padding: MediaQueries/* Mobile */.ij ? 100 : 140
    },
    // display: false,
    plugins: {
      legend: {
        display: false
      },
      datalabels: {
        font: {
          size: 12,
          family: "FbJabutinskiEng, FbJabutinski"
        },
        // display: "auto",
        textAlign: "center",
        padding: {
          left: 20
        },
        offset: MediaQueries/* Mobile */.ij ? 20 : 15,
        formatter: function formatter(value, context) {
          return context.chart.data.labels[context.dataIndex] || null;
        }
      },
      tooltip: {
        callbacks: {
          label: function label(context) {
            return context.label;
          }
        }
      }
    }
  };
  var pieOptions = {
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      },
      datalabels: {
        formatter: function formatter() {
          return null;
        },
        display: "auto"
      }
    }
  }; // add this plugins in properties of doughnut: <Doughnut redraw data={dataChart} options={chartOptions} plugins={plugins}  />
  // const plugins = [
  //   {
  //     beforeInit: function (chart) {
  //       chart.data.labels.forEach(function (e, i, a) {
  //         if (/\n/.test(e)) {
  //           a[i] = e.split(/\n/);
  //         }
  //       });
  //     },
  //   },
  // ];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SharedHoldersChartWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledPieWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* Pie */.by, {
        data: dataChart,
        options: pieOptions
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledDoughnutWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* Doughnut */.$I, {
        redraw: true,
        data: dataChart,
        options: chartOptions,
        "aria-label": t("canvasAria")
      })
    })]
  });
};

/* harmony default export */ var shareHolders_SharedHoldersChart = (SharedHoldersChart);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Table/Table.js
var Table = __webpack_require__(82302);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableBody/TableBody.js
var TableBody = __webpack_require__(99613);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableRow/TableRow.js
var TableRow = __webpack_require__(57394);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableCell/TableCell.js
var TableCell = __webpack_require__(88222);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TableContainer/TableContainer.js
var TableContainer = __webpack_require__(56847);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(75741);
;// CONCATENATED MODULE: ./components/shareHolders/ShareHoldersTable.tsx









var StyledTableContainer = (0,styled_components_browser_esm/* default */.ZP)(TableContainer/* default */.Z).withConfig({
  displayName: "ShareHoldersTable__StyledTableContainer",
  componentId: "sc-1s7rjgd-0"
})(["width:328px;border:1px solid ", ";padding:0 11px;margin-bottom:11px;.MuiTableRow-root:last-of-type{th,td{border:none;}}"], colors/* default.activitiesBorder */.Z.activitiesBorder);
var StyleTableCell = (0,styled_components_browser_esm/* default */.ZP)(TableCell/* default */.Z).withConfig({
  displayName: "ShareHoldersTable__StyleTableCell",
  componentId: "sc-1s7rjgd-1"
})(["padding:12px 0;color:", ";font-size:12px;"], function (p) {
  return p.$isValue ? colors/* default.black */.Z.black : colors/* default.gray */.Z.gray;
});

var ShareHoldersTable = function ShareHoldersTable(_ref) {
  var dataSharedHolders = _ref.dataSharedHolders;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTableContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Table/* default */.Z, {
        role: "presentation",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableBody/* default */.Z, {
          children: dataSharedHolders === null || dataSharedHolders === void 0 ? void 0 : dataSharedHolders.map(function (row, i) {
            var _row$shareholderName, _row$sharePercentage;

            return /*#__PURE__*/(0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyleTableCell, {
                component: "th",
                scope: "row",
                children: (_row$shareholderName = row.shareholderName) === null || _row$shareholderName === void 0 ? void 0 : _row$shareholderName.value
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyleTableCell, {
                $isValue: true,
                align: "right",
                children: [(_row$sharePercentage = row.sharePercentage) === null || _row$sharePercentage === void 0 ? void 0 : _row$sharePercentage.value, "%"]
              })]
            }, i);
          })
        })
      })
    })
  });
};

/* harmony default export */ var shareHolders_ShareHoldersTable = (ShareHoldersTable);
;// CONCATENATED MODULE: ./components/shareHolders/ShareHolders.tsx












var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  component: "h2",
  variant: "h2"
}).withConfig({
  displayName: "ShareHolders__StyledTitle",
  componentId: "sc-8e1zui-0"
})(["font-size:18px;color:", ";margin:0 auto;margin-bottom:", ";", ";", "{margin-top:30px;}&:focus-visible{border:1px dashed white;outline-offset:2px;outline:2px solid black;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.black;
}, function (p) {
  return p.$showTable ? "30px" : "0";
}, GlobalStyle/* fontRegular */.T4, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledChartAndTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ShareHolders__StyledChartAndTable",
  componentId: "sc-8e1zui-1"
})(["display:flex;flex-direction:column;align-items:center;padding-bottom:75px;", "{padding-bottom:", ";}"], function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return !p.$showTable ? "106px" : "40px";
});
var StyledActualDate = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "ShareHolders__StyledActualDate",
  componentId: "sc-8e1zui-2"
})(["margin-bottom:30px;font-size:12px;", "{margin-top:80px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledAccessibleTable = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "ShareHolders__StyledAccessibleTable",
  componentId: "sc-8e1zui-3"
})(["background-color:transparent;border:none;font-size:14px;text-decoration:underline;cursor:pointer;color:", ";", ";font-weight:400;margin-top:15px;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.black;
}, GlobalStyle/* fontRegular */.T4);

var ShareHolders = function ShareHolders(_ref3) {
  var _shareHoldersData$sha, _shareHoldersData$sha2, _shareHoldersData$pos, _shareHoldersData$pos2, _image$media, _image$media2, _image$media3, _poster$media, _shareHoldersData$sha5, _shareHoldersData$sha6, _shareHoldersData$sha7, _shareHoldersData$sha8;

  var shareHoldersData = _ref3.shareHoldersData;
  var headerRef = (0,react.useRef)();

  var _useState = (0,react.useState)(false),
      showTable = _useState[0],
      setShowTable = _useState[1];

  var _useState2 = (0,react.useState)(""),
      formattedDate = _useState2[0],
      setFormattedDate = _useState2[1];

  var t = (0,next_intl_cjs_production_min.useTranslations)("investor-relations");
  var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
  var image = isDesktop ? (_shareHoldersData$sha = shareHoldersData.shareHolder) === null || _shareHoldersData$sha === void 0 ? void 0 : _shareHoldersData$sha.mediaDesktop : (_shareHoldersData$sha2 = shareHoldersData.shareHolder) === null || _shareHoldersData$sha2 === void 0 ? void 0 : _shareHoldersData$sha2.mediaMobile;
  var poster = isDesktop ? (_shareHoldersData$pos = shareHoldersData.poster) === null || _shareHoldersData$pos === void 0 ? void 0 : _shareHoldersData$pos.posterDesktop : (_shareHoldersData$pos2 = shareHoldersData.poster) === null || _shareHoldersData$pos2 === void 0 ? void 0 : _shareHoldersData$pos2.posterMobile;
  (0,react.useEffect)(function () {
    var _shareHoldersData$sha3, _shareHoldersData$sha4;

    getDateFormatted(shareHoldersData === null || shareHoldersData === void 0 ? void 0 : (_shareHoldersData$sha3 = shareHoldersData.shareHolder) === null || _shareHoldersData$sha3 === void 0 ? void 0 : (_shareHoldersData$sha4 = _shareHoldersData$sha3.dbUpdateTimestamp) === null || _shareHoldersData$sha4 === void 0 ? void 0 : _shareHoldersData$sha4.value);
  }, [shareHoldersData]);

  var getDateFormatted = function getDateFormatted(date) {
    var formattedDate = new Date(date);
    var dd = formattedDate.getDate();
    var mm = formattedDate.getMonth() + 1;
    var yyyy = formattedDate.getFullYear();
    setFormattedDate("".concat(dd, ".").concat(mm, ".").concat(yyyy));
  };

  var handleSwitchTables = function handleSwitchTables() {
    setTimeout(function () {
      var _headerRef$current;

      headerRef === null || headerRef === void 0 ? void 0 : (_headerRef$current = headerRef.current) === null || _headerRef$current === void 0 ? void 0 : _headerRef$current.focus();
    }, 0);
    setShowTable(function (prevState) {
      return !prevState;
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StickyImagePageLayout/* default */.Z, {
    imageUrl: image === null || image === void 0 ? void 0 : (_image$media = image.media) === null || _image$media === void 0 ? void 0 : _image$media.publicUrl,
    altText: image === null || image === void 0 ? void 0 : (_image$media2 = image.media) === null || _image$media2 === void 0 ? void 0 : _image$media2.altText,
    type: image === null || image === void 0 ? void 0 : (_image$media3 = image.media) === null || _image$media3 === void 0 ? void 0 : _image$media3.type,
    poster: poster === null || poster === void 0 ? void 0 : (_poster$media = poster.media) === null || _poster$media === void 0 ? void 0 : _poster$media.publicUrl,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Description/* default */.Z, {
        data: {
          title: shareHoldersData.navigationTitle,
          subtitle: (_shareHoldersData$sha5 = shareHoldersData.shareHolder) === null || _shareHoldersData$sha5 === void 0 ? void 0 : (_shareHoldersData$sha6 = _shareHoldersData$sha5.subtitle) === null || _shareHoldersData$sha6 === void 0 ? void 0 : _shareHoldersData$sha6.value,
          description: (_shareHoldersData$sha7 = shareHoldersData.shareHolder) === null || _shareHoldersData$sha7 === void 0 ? void 0 : (_shareHoldersData$sha8 = _shareHoldersData$sha7.description) === null || _shareHoldersData$sha8 === void 0 ? void 0 : _shareHoldersData$sha8.value
        },
        parentPageType: "investor-relations"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledChartAndTable, {
        $showTable: showTable,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
          ref: headerRef,
          $showTable: showTable,
          tabIndex: -1,
          children: t("distribution")
        }), !showTable && /*#__PURE__*/(0,jsx_runtime.jsx)(shareHolders_SharedHoldersChart, {
          dataSharedHolders: shareHoldersData === null || shareHoldersData === void 0 ? void 0 : shareHoldersData.details
        }), showTable && /*#__PURE__*/(0,jsx_runtime.jsx)(shareHolders_ShareHoldersTable, {
          dataSharedHolders: shareHoldersData === null || shareHoldersData === void 0 ? void 0 : shareHoldersData.details
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledActualDate, {
          children: [t("lastUpdate"), " ", formattedDate]
        }), !showTable && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledAccessibleTable, {
          onClick: handleSwitchTables,
          children: t("toAccessible")
        }), showTable && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledAccessibleTable, {
          onClick: handleSwitchTables,
          children: t("backToChart")
        })]
      })]
    })
  });
};

/* harmony default export */ var shareHolders_ShareHolders = (ShareHolders);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./src/pages/investor-relations/shareholders.tsx





var __N_SSG = true;

var shareholders = function shareholders(_ref) {
  var _shareHolders$ogImage, _shareHolders$ogImage2;

  var shareHolders = _ref.shareHolders;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: shareHolders === null || shareHolders === void 0 ? void 0 : shareHolders.metaTitle,
      description: shareHolders === null || shareHolders === void 0 ? void 0 : shareHolders.metaDescription,
      additionalMetaTags: [{
        name: "keywords",
        content: shareHolders === null || shareHolders === void 0 ? void 0 : shareHolders.metaKeywords
      }],
      openGraph: {
        title: (shareHolders === null || shareHolders === void 0 ? void 0 : shareHolders.ogTitle) || (shareHolders === null || shareHolders === void 0 ? void 0 : shareHolders.metaTitle),
        description: (shareHolders === null || shareHolders === void 0 ? void 0 : shareHolders.ogDescription) || (shareHolders === null || shareHolders === void 0 ? void 0 : shareHolders.metaDescription),
        images: [{
          url: (shareHolders === null || shareHolders === void 0 ? void 0 : (_shareHolders$ogImage = shareHolders.ogImage) === null || _shareHolders$ogImage === void 0 ? void 0 : (_shareHolders$ogImage2 = _shareHolders$ogImage.media) === null || _shareHolders$ogImage2 === void 0 ? void 0 : _shareHolders$ogImage2.publicUrl) || ""
        }]
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(shareHolders_ShareHolders, {
      shareHoldersData: shareHolders
    })]
  });
};

/* harmony default export */ var investor_relations_shareholders = (shareholders);

/***/ }),

/***/ 9665:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor-relations/shareholders",
      function () {
        return __webpack_require__(44739);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2196,7611,719,5847,2020,1121,9441,9774,2888,179], function() { return __webpack_exec__(9665); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);